import React, { Component } from "react";

class Contact extends Component {
    render(){
        return(
            <div className = "content-wrapper">
            <p className="pageContent">hello, contact </p>
            <div class="push"></div>
            </div>
        )
    }
}

export default Contact;